import {
  FETCH_BRANDS_REQUEST,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  CREATE_BRAND_REQUEST,
  CREATE_BRAND_SUCCESS,
  CREATE_BRAND_FAILURE,
  UPDATE_BRAND_REQUEST,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_FAILURE,
  DELETE_BRAND_REQUEST,
  DELETE_BRAND_SUCCESS,
  DELETE_BRAND_FAILURE,
} from "../constants/actionTypes";

const initialState = {
  loading: false,
  data: [],
  error: null,
  deleteLoading: false,
};

const brandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRANDS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_BRAND_REQUEST:
    case UPDATE_BRAND_REQUEST:
      // case DELETE_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        // deleteLoading: true,
      };
    case DELETE_BRAND_REQUEST:
      return {
        ...state,
        // loading: true,
        deleteLoading: true,
      };
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case CREATE_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: [...state.data, action.payload],
      };
    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        // data: state.data.map((brand) =>
        //   brand.id === action.payload.id ? action.payload : brand
        // ),
      };
    case DELETE_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // data: state.data.data.filter(brand => brand.id !== action.payload),
      };
    case FETCH_BRANDS_FAILURE:
    case CREATE_BRAND_FAILURE:
    case UPDATE_BRAND_FAILURE:
    case DELETE_BRAND_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        // error: action.error,
      };
    default:
      return state;
  }
};

export default brandsReducer;
